import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { finalize, Subject } from 'rxjs';
import { SharedService } from '../shared.service';

@Component({
    selector: 'ashcorp-error',
    templateUrl: './error.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AshcorpErrorComponent implements OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    reported: boolean = false;

    @Output() uncrashEvent: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private _sharedService: SharedService,
        private _cdr: ChangeDetectorRef
    ) {
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    refresh(): void {
        location.reload();
    }

    report(): void {
        this._sharedService.show_loader();

        this._sharedService
            .send_error()
            .pipe(
                finalize(() => {
                    this.reported = true;
                    this._sharedService.hide_loader();
                    this._cdr.detectChanges();
                })
            )
            .subscribe();
    }

    goBack(): void {
        this.uncrashEvent.emit();
    }
}
